import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Button, Select, MenuItem, TextField, Tabs, Tab, Box, Tooltip, InputBase, IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import qs from "qs";
import CryptoJS from "crypto-js";
import "../Reports/ReportsTable.css";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import OutlinedSelect from "../OutlinedSelect";

import RefreshIcon from '@mui/icons-material/Refresh'; // Importing Refresh Icon
import SearchIcon from '@mui/icons-material/Search';
import ConsumerSummaryTable from '../Reports/ConsumerSummaryTable'; // Already imported
import DormantUsersTable from '../Reports/DormantUsersTable';
import RewardPointsBalanceTable from '../Reports/RewardPointsBalanceTable';
import { useRO } from "../Dashboards/ROContext";
import ROSelect from "../Dashboards/ROSelect";

const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
  const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const ReportsTable = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filter, setFilter] = useState("Select...");
  const [activeTab, setActiveTab] = useState("registeredUsers"); // 👈 Controls selected tab
  const [sortConfig, setSortConfig] = useState({ key: "date_created", direction: "desc" });
  const [showSearch, setShowSearch] = useState(true);
  const [searchText, setSearchText] = useState("");

   const refreshconsumersummaryRef = useRef(null);
const exportconsumersummaryRef = useRef(null);
const exportconsumersummarypdfRef = useRef(null);
  const refreshrewardpointRef = useRef(null);
const exportrewardpointRef = useRef(null);
const exportrewardpointpdfRef = useRef(null);
  const refreshDormantRef = useRef(null);
const exportDormantRef = useRef(null);
const exportDormantpdfRef = useRef(null);
  const registeredUserColumns = [
    { label: "First Name", field: "firstname" },
    { label: "Last Name", field: "lastname" },
    { label: "Email ID", field: "email" },
    { label: "Phone Number", field: "phone" },
    { label: "Vehicle Number", field: "vehiclenumber" },
    { label: "Registered On", field: "date_created" },
    {label: "Birth Date", field: "dob"}
  ];

  const REPORT_TYPES = [
  { label: "Registered Users", value: "registeredUsers" },
  { label: "Consumer Summary", value: "consumerSummary" },
  { label: "Dormant Users", value: "dormantUsers" },
  { label: "Reward Points Balance", value: "rewardPointsBalance" },
];

const { selectedRoId } = useRO();
  const searchRef = useRef();

  useEffect(() => {
    if (filter !== "Select...") {
      calculateDateRange();
    }
  }, [filter]);

  const calculateDateRange = () => {
    let today = new Date();
    let pastDate = new Date();

    switch (filter) {
      case "One Month": pastDate.setMonth(today.getMonth() - 1); break;
      case "Three Months": pastDate.setMonth(today.getMonth() - 3); break;
      case "Six Months": pastDate.setMonth(today.getMonth() - 6); break;
      case "One Year": pastDate.setFullYear(today.getFullYear() - 1); break;
      case "Custom Range": return;
      default: return;
    }

    setFromDate(pastDate.toISOString().split("T")[0]);
    setToDate(today.toISOString().split("T")[0]);
  };

  useEffect(() => {
    if (fromDate && toDate && fromDate <= toDate && activeTab === "registeredUsers") {
      fetchRegisteredUsers();
    }
  }, [fromDate, toDate, activeTab, selectedRoId]);

  const fetchRegisteredUsers = async () => {
    setLoading(true);
    setError(null);
    setData([]);

    if (filter === "Custom Range" && (!fromDate || !toDate)) {
      setError("Please select both From and To dates");
      setLoading(false);
      return;
    }

    const selectedFromDate = fromDate ? new Date(`${fromDate}T00:00:00.000Z`).toISOString() : "";
    const selectedToDate = toDate ? new Date(`${toDate}T23:59:59.999Z`).toISOString() : "";

 

    const token = localStorage.getItem("authToken");
    if (!token) {
      setError("User not authenticated");
      setLoading(false);
      return;
    }

    const method = "GET";
    const timestamp = Math.floor(Date.now() / 1000).toString();
    const apiUrl = `/v1/user/consumerdetails/referredbyme`;
    const signature = generateSignature(method, apiUrl, timestamp);
//const savedRoId = localStorage.getItem("selectedRoId");
   // Build params correctly so Custom Range works
let params = {};

// If user selected Custom Range, require both dates
if (filter === "Custom Range") {
  if (!fromDate || !toDate) {
    setError("Please select both From and To dates");
    setLoading(false);
    return;
  }
  params.start_date = selectedFromDate;
  params.end_date = selectedToDate;
}
else if (filter !== "Select...") {
  // For One Month, Three Months, etc.
  if (fromDate && toDate) {
    params.start_date = selectedFromDate;
    params.end_date = selectedToDate;
  }
}

// Attach RO filter if selected
if (selectedRoId) {
  params.ro_id = (selectedRoId);
}

// Final encoded URL params
const queryParams = qs.stringify(params);


    try {
      const response = await axios.get(`${API_BASE_URL}${apiUrl}?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Signature": signature,
          "X-Timestamp": timestamp,
        },
});

      const users = Array.isArray(response.data.users) ? response.data.users : [];
      if (users.length > 0) {
        const sortedUsers = sortData(users, sortConfig.key, sortConfig.direction);
         
        setData(sortedUsers);
        setColumns(Object.keys(users[0]));

      } else {
        setData([]);
        setColumns([]);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch data");
    }

    setLoading(false);
  };

  const sortData = (dataList, key, direction) => {
    return [...dataList].sort((a, b) => {
      const valA = a[key];
      const valB = b[key];

      if (!valA || !valB) return 0;

      if (direction === "asc") {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });
  };

  const handleSort = (field) => {
    let direction = "asc";
    if (sortConfig.key === field && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: field, direction });

    const sorted = sortData(data, field, direction);
    setData(sorted);
  };

  const handleExport = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
  data.map(row => {
    let rowData = {};

    registeredUserColumns.forEach(col => {
      const value = col.field ? (row[col.field] ?? "N/A") : "N/A";

      // ✅ DOB → "21st Jan"
      if (col.field === "dob") {
        rowData[col.label] = formatDOB(value);
      }
      // ✅ Other date fields → full date-time
      else if (
        typeof value === "string" &&
        col.field?.toLowerCase().includes("date")
      ) {
        try {
          const d = new Date(value);
          rowData[col.label] = isNaN(d.getTime())
            ? value
            : d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
        } catch {
          rowData[col.label] = value;
        }
      }
      // ✅ Normal fields
      else {
        rowData[col.label] = value || "N/A";
      }
    });

    return rowData;
  })
);

      
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registered Users");
    XLSX.writeFile(workbook, `registered_users.xlsx`);
  };
const handleExportPDF = (fileName = "registered_users.pdf") => {
  if (!data || data.length === 0) {
    alert("No data to export!");
    return;
  }

  // Build header row from registeredUserColumns
  const headers = registeredUserColumns.map(col => col.label);

  // Build body rows in the same order as headers
  const body = data.map(row => {
  return registeredUserColumns.map(col => {
    const value = col.field ? (row[col.field] ?? "N/A") : "N/A";

    // ✅ DOB formatting (NO year)
    if (col.field === "dob") {
      return formatDOB(value);
    }

    // ✅ Other date fields (full date-time)
    if (
      typeof value === "string" &&
      (col.field || "").toLowerCase().includes("date")
    ) {
      try {
        const d = new Date(value);
        return isNaN(d.getTime())
          ? value
          : d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
      } catch {
        return value;
      }
    }

    return value;
  });
});


  // Create PDF
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: "a4"
  });

  // Optional title
  const title = "Registered Users";
  const marginLeft = 40;
  const startY = 40;
  doc.setFontSize(14);
  doc.text(title, marginLeft, startY);

  // Use autoTable
  autoTable(doc, {
    startY: startY + 10,
    head: [headers],
    body: body,
    styles: { fontSize: 10, cellPadding: 6 },
    headStyles: { fillColor: [240, 240, 240], textColor: 20, fontStyle: "bold" },
    footStyles: { fillColor: [240, 240, 240] },
    margin: { left: marginLeft, right: marginLeft / 2 },
    didDrawPage: (dataArg) => {
      // add page number in footer
      const pageCount = doc.getNumberOfPages();
      doc.setFontSize(9);
      const pageStr = `Page ${dataArg.pageNumber}`;
      doc.text(pageStr, doc.internal.pageSize.getWidth() - 60, doc.internal.pageSize.getHeight() - 10);
    },
    // optional: columnStyles to wrap long text or set width
    // columnStyles: { 0: { cellWidth: 120 } }
  });

  // Save file
  doc.save(fileName);
};

  const formatDOB = (dob) => {
  if (!dob || dob === "N/A") return "-";

  let date;

  // Try direct Date parsing (ISO / timestamp)
  const d1 = new Date(dob);
  if (!isNaN(d1.getTime())) {
    date = d1;
  } else {
    // Handle DD-MM-YYYY or DD/MM/YYYY
    const parts = dob.split(/[-/]/);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const d2 = new Date(`${year}-${month}-${day}`);
      if (!isNaN(d2.getTime())) {
        date = d2;
      }
    }
  }

  if (!date) return "-";

  const day = date.getDate();
  const month = date.toLocaleString("en-IN", { month: "short" });

  // Ordinal suffix logic
  const getSuffix = (d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${day}${getSuffix(day)} ${month}`;
};
  return (
    <>
      <div className="transaction-container"style={{ gap:"15px" }}>
        
<div className="controls-container" style={{ display: "flex", gap: "10px" }}>
  
      <div className="ro-dropdown" style={{ color:"black" }}>
        <ROSelect className="roSelectInline" theme="light" labelClassName="roLable" />
      </div>
  
  <OutlinedSelect
  label="Report Type"
  value={activeTab}
  minWidth={220}
  onChange={(e) => {
    setActiveTab(e.target.value);
    setData([]);
    setError(null);
  }}
  options={REPORT_TYPES}
/>
        {/* ✅ Hide filter dropdown when Dormant Users tab is active */}
          {activeTab !== "dormantUsers" && (
            <>
              <OutlinedSelect
  label="Select Range"
  value={filter}
  minWidth={200}
  onChange={(e) => {
    const selectedValue = e.target.value;
    setFilter(selectedValue);
    if (selectedValue === "Select...") {
      setData([]);
      setError(null);
    }
  }}
  options={[
    { label: "Select...", value: "Select..." },
    { label: "One Month", value: "One Month" },
    { label: "Three Months", value: "Three Months" },
    { label: "Six Months", value: "Six Months" },
    { label: "One Year", value: "One Year" },
    { label: "Custom Range", value: "Custom Range" },
  ]}
/>

              {filter === "Custom Range" && (
                <>
                  <TextField type="date" label="From" value={fromDate} onChange={(e) => setFromDate(e.target.value)} InputLabelProps={{ shrink: true }} />
                  <TextField type="date" label="To" value={toDate} onChange={(e) => setToDate(e.target.value)} InputLabelProps={{ shrink: true }} />
                </>
              )}
            </>
          )}

          <Tooltip title="Refresh">
            <Button onClick={() => {
              if (activeTab === "dormantUsers") {
                refreshDormantRef.current && refreshDormantRef.current();

              } else if (activeTab === "rewardPointsBalance") {
                refreshrewardpointRef.current && refreshrewardpointRef.current();
              } else if (activeTab === "consumerSummary") {
                refreshconsumersummaryRef.current && refreshconsumersummaryRef.current();
              }
              else {
                fetchRegisteredUsers();
              }
            } }
              className="small-button"
            ><RefreshIcon /></Button>
          </Tooltip>
          <Tooltip title="Download to Excel">
            <Button onClick={() => {
              if (activeTab === "dormantUsers") {
                exportDormantRef.current && exportDormantRef.current();
              }
              else if (activeTab === "rewardPointsBalance") {
                exportrewardpointRef.current && exportrewardpointRef.current();
              }
              else if (activeTab === "consumerSummary") {
                exportconsumersummaryRef.current && exportconsumersummaryRef.current();
              }
              else {
                handleExport();
              }
            } }
              className="small-button"
            ><FileDownloadOutlinedIcon /></Button>
          </Tooltip>
          <Tooltip title="Download to PDF">
            <Button onClick={() => {
              if (activeTab === "dormantUsers") {
                exportDormantpdfRef.current && exportDormantpdfRef.current();
              }
              else if (activeTab === "rewardPointsBalance") {
                exportrewardpointpdfRef.current && exportrewardpointpdfRef.current();
              }
              else if (activeTab === "consumerSummary") {
                exportconsumersummarypdfRef.current && exportconsumersummarypdfRef.current();
              }
              else {
                handleExportPDF();
              }
            } }
              className="small-button"
            ><PictureAsPdfIcon/></Button>
          </Tooltip>

          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }} ref={searchRef}>
            {showSearch && (
              <div style={{ position: "relative", display: "flex", alignItems: "center", background: "#f0f0f0", paddingLeft: 10, marginTop: 5, borderRadius: 5 }}>
                <InputBase placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} style={{ flex: 1 }} />
                {searchText && (
                  <IconButton className="close-button" size="small" onClick={() => setSearchText("")}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Content based on active tab style={{border:"2px solid #a7a4a4"}}*/}
        {activeTab === "registeredUsers" && (
          <div>
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>{error}</p>
            ) : (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ background: "lightgrey" }}>
                      {registeredUserColumns.map(col => (
                        <TableCell key={col.label} onClick={() => handleSort(col.field)} style={{ cursor: "pointer", fontWeight: "bold", border: "2px solid #a7a4a4" }}>
                          {col.label}
                          {sortConfig.key === col.field ? (sortConfig.direction === "asc" ? " 🔼" : " 🔽") : ""}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.filter(row => Object.values(row).some(val => String(val).toLowerCase().includes(searchText.toLowerCase())
                    )
                    ).map((row, index) => (
                      <TableRow key={index}>
                        {registeredUserColumns.map((col, colIndex) => (
                          <TableCell key={`${index}-${colIndex}`}>
  {col.field === "dob"
    ? formatDOB(row.dob)
    : col.field.toLowerCase().includes("date")
      ? (row[col.field]
          ? new Date(row[col.field]).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
            })
          : "N/A")
      : row[col.field] || "N/A"}
</TableCell>

                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        )}

        {activeTab === "consumerSummary" && (
          <ConsumerSummaryTable
            filter={filter}
            fromDate={fromDate ? new Date(`${fromDate}T00:00:00.000Z`).toISOString() : ""}
            toDate={toDate ? new Date(`${toDate}T23:59:59.999Z`).toISOString() : ""}  
            searchQuery={searchText}
             selectedRoId={selectedRoId}
            onExportRef={exportconsumersummaryRef}
            onRefreshRef={refreshconsumersummaryRef} 
            onExportpdfRef={exportconsumersummarypdfRef}/>
        )}

        {activeTab === "dormantUsers" && (
          <DormantUsersTable
            fromDate={fromDate ? new Date(`${fromDate}T00:00:00.000Z`).toISOString() : ""}
            toDate={toDate ? new Date(`${toDate}T23:59:59.999Z`).toISOString() : ""}
            searchQuery={searchText}
            onRefreshRef={refreshDormantRef}
            onExportRef={exportDormantRef}
            selectedRoId={selectedRoId}
            onExportpdfRef={exportDormantpdfRef} />
        )}
        {activeTab === "rewardPointsBalance" && (
          <RewardPointsBalanceTable
            searchQuery={searchText}
            fromDate={fromDate ? new Date(`${fromDate}T00:00:00.000Z`).toISOString() : ""}
            toDate={toDate ? new Date(`${toDate}T23:59:59.999Z`).toISOString() : ""}
            filter={filter}
            onExportRef={exportrewardpointRef}
            onRefreshRef={refreshrewardpointRef} 
            selectedRoId={selectedRoId}
            onExportpdfRef={exportrewardpointpdfRef}/>
        )}


      </div></>
  );
};

export default ReportsTable;
